document.addEventListener('DOMContentLoaded', () => {
    window.themeMobileMenu = new MobileMenu()
})

export default class MobileMenu {

    constructor() {

        this.mobileMenu = new Mmenu('#mobile-navigation-container', {
            'navbar': {
                'add': false
            },
            'navbars': [
                {
                    'position': 'top',
                    'content': [
                        'prev',
                        'title',
                        'close'
                    ]
                },
                {
                    'position': 'bottom',
                    'content': [
                        '<a href="#" id="mobile-menu-group-sites">' +
                        '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 448 368" aria-hidden="true"><path id="bars-regular" d="M0,88A24.006,24.006,0,0,1,24,64H424a24,24,0,0,1,0,48H24A23.974,23.974,0,0,1,0,88ZM0,248a23.974,23.974,0,0,1,24-24H424a24,24,0,0,1,0,48H24A23.974,23.974,0,0,1,0,248ZM424,432H24a24,24,0,0,1,0-48H424a24,24,0,0,1,0,48Z" transform="translate(0 -64)"/></svg>' +
                        'Our Group</a>',
                        '<a href="search" id="mobile-menu-search">' +
                        '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18.003" viewBox="0 0 18 18.003" aria-hidden="true"><path id="Search_icon" data-name="Search icon" d="M17.755,15.565,14.25,12.059a.843.843,0,0,0-.6-.246h-.573a7.31,7.31,0,1,0-1.266,1.266v.573a.843.843,0,0,0,.246.6l3.505,3.505a.84.84,0,0,0,1.192,0l.995-.995A.848.848,0,0,0,17.755,15.565ZM7.313,11.813a4.5,4.5,0,1,1,4.5-4.5A4.5,4.5,0,0,1,7.313,11.813Z" transform="translate(0)" /></svg>' +
                        'Search</a>'
                    ]
                }
            ]
        })

        this.mmAPI = this.mobileMenu.API

        document.querySelector('#main-header .navbar-toggler').addEventListener('click', (e) => {
            e.preventDefault()
            this.mmAPI.open()
        })

        document.querySelector('#mobile-menu-group-sites').addEventListener('click', (e) => {
            e.preventDefault()
            this.mmAPI.close()

            setTimeout(() => {
                window.themeGroupSitesMenu.dialogFocusTrap.activate()
            }, 300)
        })
    }

}